<template>
    <!-- Main Wrapper -->
    <div class="main-wrapper">
        <!-- Header -->
        <layout-header />
        <!-- /Header -->

        <!-- Page Content -->
        <div class="content container">
            <div class="px-3">
                <div class="row">
                    <div class="col-lg-3 d-lg-block d-none theiaStickySidebar mb-3">
                        <div class="stickyside">
                            <!-- Profile Sidebar -->
                            <div class="rounded-xl d-none d-lg-block shadow-sm p-2"><customer-sidebar></customer-sidebar></div>
                            <!-- /Profile Sidebar -->
                        </div>
                    </div>
                    <!-- / Profile Sidebar -->

                    <div class="col-lg-9 col-md-12 mb-5">
                        <div class="border-bottom mb-3">
                            <h2>Classement</h2>
                        </div>

                        <div>
                            <div class="d-flex justify-content-center align-items-center">
                                <a v-for="tab in tabs" @click="fetchStandings(tab.id)" :class="{ 'bg-warning-light': activeTab === tab.id }" 
                                    href="javascript:void(0)" class="badge badge-pill text-dark bg-light text-xs mr-1 py-3 px-4">{{ tab.label }}</a>
                            </div>
                        </div>

                        <div class="tab-content py-3 mb-5">
                            <div class="tab-pane fade show active pt-3">
                                <div v-if="activeTab === 'teams'" class="text-center">
                                    <span class="text-sm">Pas encore de classement pour les équipes, restez à l'écoute !</span>
                                </div>
                                <div v-else>
                                    <nav class="mt-3" v-if="totalPages > 1">
                                        <ul class="pagination justify-content-center">
                                            <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                                <button class="page-link text-dark" @click="goToPage(currentPage - 1)">
                                                    <span class="material-symbols-outlined text-sm">arrow_back</span>
                                                </button>
                                            </li>
                                            <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                                                <button class="page-link text-dark" @click="goToPage(currentPage + 1)">
                                                    <span class="material-symbols-outlined text-sm">arrow_forward</span>
                                                </button>
                                            </li>
                                        </ul>
                                    </nav>
                                    <div class="table-responsive text-xs p-lg-2 p-0">
                                        <table class="table table-hover table-center mb-0">
                                            <thead class="bg-light">
                                                <tr>
                                                    <th style="width: 10%;">#</th>
                                                    <th v-if="activeTab === 'players'">Nom Joueur</th>
                                                    <th v-else>Nom Équipe</th>
                                                    <th style="width: 30%">Points</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, index) in paginatedData" :key="index">
                                                    <td>{{ (currentPage - 1) * perPage + index + 1 }}</td>
                                                    <td v-if="activeTab === 'players'" :class="{'font-weight-bolder': item.id === currentUser.id}">{{ item.name }}</td>
                                                    <td v-else>{{ item.name }}</td>
                                                    <td>{{ item.points }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- /Page Content -->

        <!-- Footer -->
        <layout-footer />
        <!-- /Footer -->
    </div>
</template>
<style scoped>
/* .rankings-container { max-width: 800px; margin: 0 auto; background: #fff; padding: 20px; border-radius: 8px; box-shadow: 0 4px 8px rgba(0,0,0,0.1); }
h2 { text-align: center; color: #333; }
table { width: 100%; border-collapse: collapse; margin-top: 20px; }
th, td { text-align: left; padding: 12px; border-bottom: 1px solid #ddd; }
th { background-color: #004a99; color: white; }
tr:hover { background-color: #f1f1f1; }
.rank { font-weight: bold; color: #004a99; text-align: center; }
.player-name { font-weight: 500; }
.points { color: #555; text-align: right; }
.player-info { display: flex; align-items: center; }
.flag { margin-right: 10px; width: 25px; height: auto; } */
</style>
<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import moment from "moment";
import 'moment/locale/fr';
import { api } from "@/store";
import defaultLogoPath from '@/assets/img/default-team-logo.png'
import CustomerSidebar from "@/components/Customers/Partials/Sidebar";

export default {
    components: {
        "customer-sidebar": CustomerSidebar,
        vSelect
    },
    computed: {
        currentUser() {
            return this.$store.getters.currentUser;
        },
        totalPages() {
            return Math.ceil(this.data.length / this.perPage);
        },
        paginatedData() {
            const start = (this.currentPage - 1) * this.perPage;
            return this.data.slice(start, start + this.perPage);
        },
    },
    data() {
        return {
            defaultLogoPath,
            activeTab: 'players',
            data: [],
            currentPage: 1,
            perPage: 20,
            tabs: [
                { id: 'players', label: 'Joueurs', data: [] },
                { id: 'teams', label: 'Équipes', data: [] },
            ],
        };
    },
    methods: {
        fetchStandings(entity = null) {
            entity = entity ? entity: this.activeTab
            this.activeTab = entity
            this.currentPage = 1
            api.get(`/private/${entity}/standing`)
                .then(response => {
                    const result = response.data
                    this.data = result
                });
        },
        goToPage(page) {
            if (page >= 1 && page <= this.totalPages) {
                this.currentPage = page;
            }
        },
    },
    created() {
        this.fetchStandings()
    }
};
</script>